import React from "react";
import { ChevronDown, Github, Linkedin, Mail } from "lucide-react";
// load image from assets
import Yassine from "../assets/Yassine.jpg";

const Hero = () => {
  return (
    <section id="home" className="min-h-screen flex items-center bg-gradient-to-br from-indigo-50 to-blue-100 pt-16">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-between">
          <div className="md:w-1/2 mb-10 md:mb-0">
            <div className="space-y-4 max-w-lg">
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-800 leading-tight">
                Hello, I'm <span className="text-indigo-600">Yassine Ibork</span>
              </h1>
              
              <p className="text-xl text-gray-600">
                PhD Student in Computer Science specializing in computer vision, machine learning, and autonomous systems.
              </p>
              
              <div className="pt-4 flex flex-wrap gap-4">
                <a 
                  href="#research" 
                  className="px-6 py-3 bg-indigo-600 text-white font-medium rounded-lg shadow-md hover:bg-indigo-700 transition-colors"
                >
                  My Research
                </a>
                <a 
                  href="#contact"
                  className="px-6 py-3 bg-white text-indigo-600 font-medium rounded-lg shadow-md border border-indigo-200 hover:bg-indigo-50 transition-colors"
                >
                  Contact Me
                </a>
              </div>
              
              <div className="pt-6 flex items-center space-x-4">
                <a href="https://github.com" target="_blank" rel="noreferrer" className="text-gray-700 hover:text-indigo-600 transition-colors">
                  <Github className="w-6 h-6" />
                </a>
                <a href="https://linkedin.com" target="_blank" rel="noreferrer" className="text-gray-700 hover:text-indigo-600 transition-colors">
                  <Linkedin className="w-6 h-6" />
                </a>
                <a href="mailto:y.ibork1@gmail.com" className="text-gray-700 hover:text-indigo-600 transition-colors">
                  <Mail className="w-6 h-6" />
                </a>
              </div>
            </div>
          </div>
          
          <div className="md:w-1/2 flex justify-center">
            <div className="relative">
              <div className="w-64 h-64 sm:w-80 sm:h-80 bg-indigo-600 rounded-full overflow-hidden border-8 border-white shadow-xl">
              <img 
                src={Yassine}
                alt="Yassine Ibork"
                className="w-full h-full object-cover"
/>              </div>
              <div className="absolute -bottom-6 -right-6 bg-white rounded-lg shadow-lg p-4">
                <p className="font-bold text-indigo-600">
                  PhD Researcher
                </p>
              </div>
            </div>
          </div>
        </div>
        
        <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce">
          <a href="#about" className="flex items-center justify-center w-10 h-10 rounded-full bg-white shadow-md">
            <ChevronDown className="w-6 h-6 text-indigo-600" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;